// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__J2TSR","noClose":"Modal_noClose__JQwWA","card":"Modal_card__XMJLk","close":"Modal_close__UaXD8","icon":"Modal_icon__lSsqs"};